/* StorefrontConfigContext — layout tenant dari TenantConfiguration ACTIVE/PRODUCTION.
   Sumber: GET /api/public/storefront-config (deterministik, fallback netral).
   Dipakai storefront (Home, Layout, ProductCard) — skema sama dengan Live Preview. */
import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

export const NEUTRAL_STOREFRONT_CONFIG = {
  design: {
    header_style: "sticky-with-search",
    footer_style: "columns-4",
    homepage_layout: "banner-sections-grid",
    banner_slider: true,
    product_card_style: "rounded",
    category_layout: "top-chips",
    button_style: "rounded",
  },
  dna: {
    homepage_sections: [],
    product_layout: "grid-4-col",
    inventory_units: [],
    banner_style: "slider",
    product_card: "compact-image-top",
    trust_badges: [],
  },
  source: null,
};

const Ctx = createContext({ config: NEUTRAL_STOREFRONT_CONFIG, loading: true });

export function StorefrontConfigProvider({ children }) {
  const [state, setState] = useState({ config: NEUTRAL_STOREFRONT_CONFIG, loading: true });
  useEffect(() => {
    api.get("/public/storefront-config")
      .then((r) => setState({
        config: {
          design: { ...NEUTRAL_STOREFRONT_CONFIG.design, ...(r.data?.design || {}) },
          dna: { ...NEUTRAL_STOREFRONT_CONFIG.dna, ...(r.data?.dna || {}) },
          source: r.data?.source || null,
        },
        loading: false,
      }))
      .catch(() => setState((s) => ({ ...s, loading: false })));
  }, []);
  return <Ctx.Provider value={state}>{children}</Ctx.Provider>;
}

export const useStorefrontConfig = () => useContext(Ctx);
